import { useEffect } from "react";
import { useDepartments } from "@/api/queries/departments";
import { registerAccountContext } from "./mixpanel";

/**
 * Register account-level analytics context (the department's plan tier) for the
 * signed-in chief, so dashboard engagement is segmentable for pricing — e.g.
 * which pilot departments are highly engaged and ready to convert/upsell.
 *
 * Mounted once in the authenticated shell. `registerAccountContext` is a no-op
 * unless analytics is on AND the session is a chief, so this is safe to run for
 * every authenticated user, and it reuses the `departments` query the topbar
 * switcher already loads — no extra request.
 */
export function useAnalyticsAccountContext(): void {
  const { data: departments } = useDepartments();
  // A chief belongs to exactly one department, so the first (only) row is theirs.
  const plan = departments?.[0]?.plan_tier;
  useEffect(() => {
    registerAccountContext({ plan });
  }, [plan]);
}
